<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faVolume,faSpinnerThird,faPhoneHangup } from '@fortawesome/pro-regular-svg-icons'
library.add(faVolume,faSpinnerThird,faPhoneHangup);
import {_} from 'vue-underscore';


import Treeselect from '@riophae/vue-treeselect'
import { LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';

// import the styles

export default {
	page: {
		title: 'Data Farming - Edit List',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader,FontAwesomeIcon,Treeselect,_},
	methods:
	{
		edit_list: function()
		{
			
			this.PageComponents.hasError = false;

			if(this.listDeatils.name == '')
			{
				 this.$bvModal.msgBoxOk('Please give a name to your list.', {titleHtml: "<b>Error<b>"});
			}
			else
			{

				
				 this.PageComponents.loading = true;

				 axios.post(appConfig.api+'audience/edit_farming/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser")),data:this.listDeatils,paths:this.paths,techology:this.targeting,id:this.$route.params.id})
 		      		.then((response) =>
 		      		{
						if(response.data)
						{
							if(response.data.status == false)
							{
									if(response.data.code == 401)
									{
										//invalud session
										this.$router.push('/logout');
									}
									else
									{
										this.PageComponents.loading = false;
										this.PageComponents.hasError = true;
										this.PageComponents.errorMsgs = response.data.error_message;
										
									}
							}
							else
							{
								this.PageComponents.loading = false;
								this.$bvModal.msgBoxOk("List successfully updated.", {titleHtml: "<b>Success<b>"}).then(value => {
									//this.$router.push('/dsp/audience/farming');

									console.log('/audience/farming/view/'+this.$route.params.id+'?forceupdate=true');
									this.$router.push('/audience/farming/view/'+this.$route.params.id+'?forceupdate=true');
				 				});

							}
						}
						else
						{
							this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
						}

					})
 		      .catch((error) =>
 		      {
 					//other error
 					this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
 		      })
			}

		},
		addBulkLocations: function(bvModalEvent)
		{
			bvModalEvent.preventDefault();
			if(this.bulk_list == '')
			{
				this.$bvModal.msgBoxOk("Please enter at less one location", {titleHtml: "<b> Error<b>"});
			}
			else
			{
				var list = this.bulk_list.split("\n");
				var validaied_list = new Array();
				const regexExp = /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;
				var itemsProcessed = 0;

				list.forEach(element => 
				{
					itemsProcessed++;

					if(element.includes(","))
					{
						var ele = element.split(';');
						if(ele.length > 0)
						{
							if(regexExp.test(ele[0]))
							{
								var pos = ele[0].split(',');
								if(pos.length == 2)
								{
									var marker = {lat:pos[0],lng:pos[1]};
									var radius = (ele[1] !== undefined) ? parseInt(ele[1]) : 1000;
									var notes  = (ele[2] !== undefined)? ele[2] : '';

									validaied_list.push({ position: marker,radius:1000,notes:notes});
								}
							}
						}
					}

					if(itemsProcessed === list.length) {
						//All Done
						if(validaied_list.length > 0){
							
							validaied_list.forEach(loc => 
							{
								this.listDeatils.locations.push(loc);
							});

							this.$nextTick(() => {      
								this.$bvModal.hide('bulklist');
							})

							this.bulk_list = '';
						}
						else
						{
							this.$bvModal.msgBoxOk("We didn't find any valid locations on your list", {titleHtml: "<b> Error<b>"});
						}
					}


				});

				

			}
		},
		removePostion(row)
		{
			this.listDeatils.locations.splice(row.index, 1);
		},
		open_add_new() {
			this.$refs.dropdown.show();
		},
		addMarker: function(event)
	   {
		 	const marker = {
				lat: event.latLng.lat(),
				lng: event.latLng.lng(),
      		}

			this.listDeatils.locations.push({ position: marker,radius:1000,notes:''});
	  	},
		  updateEdited: function (mvcPaths) {
            this.mvcPaths = mvcPaths
          },
		setPlace: async function(event)
		{

			this.zoom = 15;
			this.paths.splice(this.paths.length - 1, 1);
			this.listDeatils.locations = [];

		
			
			const marker = {
				lat: event.geometry.location.lat(),
				lng: event.geometry.location.lng(),
      		}

			this.listDeatils.locations.push({ position: marker,radius:1000,notes:''});

			this.current_location = marker;
			

			const delay = ms => new Promise(res => setTimeout(res, ms));

			await delay(1000);

			// obtain the bounds, so we can guess how big the polygon should be
			var bounds = this.$refs.map.$mapObject.getBounds()
            var northEast = bounds.getNorthEast()
            var southWest = bounds.getSouthWest()
            var center = bounds.getCenter()
            var degree = this.paths.length + 1;
            var f = Math.pow(0.66, degree);

		

			// Draw a triangle. Use f to control the size of the triangle.
            // i.e., every time we add a path, we reduce the size of the triangle
            var path = [
              { lng: center.lng(), lat: (1-f) * center.lat() + (f) * northEast.lat() },
              { lng: (1-f) * center.lng() + (f) * southWest.lng(), lat: (1-f) * center.lat() + (f) * southWest.lat() },
              { lng: (1-f) * center.lng() + (f) * northEast.lng(), lat: (1-f) * center.lat() + (f) * southWest.lat() },
            ];


			this.paths = (path);

		},
		get_list_details: function()
		{

			this.PageComponents.loading = true;

			axios.post(appConfig.api+'audience/get_farming_details/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser")),id:this.$route.params.id})
			.then((response) =>
			{ 
				this.PageComponents.loading = false;

				if(response.data)
				{
				if(response.data.status == false)
				{
					//invalud session
					this.$router.push('/logout');
				}
				else
				{
					//success Status
					this.listDeatils = response.data.list;
					this.targeting = response.data.list.techology;

					
					if(this.listDeatils.polygon !== undefined)
					{
						if(this.listDeatils.polygon.length > 2)
						{
							const marker = {
								lat: parseFloat(this.listDeatils.polygon[0].lat),
								lng: parseFloat(this.listDeatils.polygon[0].lng),
							}


							this.current_location = marker;
							this.zoom = 15;

							this.listDeatils.polygon.forEach(element => {
								var point = 
								{
									lat: parseFloat(element.lat),
									lng: parseFloat(element.lng),
								};

								this.paths.push(point);
							});

						}
							/*
							var x = this.listDeatils.polygon;
							this.paths.push(x);
							*/
					}


				}
				}
				else
				{
					this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
				}


			})
			.catch((error) =>
			{
				console.log(error);
				//other error
				this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
			})
		},
		getCountriesList()
		{
			
			axios.post(appConfig.api+'campaigns/get_country_list/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser"))})
			.then((response) =>
			{ 
				
				this.countiresList = response.data.list;
				//this.listDeatils.farming_country = response.data.selected;
				

			});
		},
		getISPList(node)
		{
			
			axios.post(appConfig.api+'campaigns/get_isp_list/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser")),search:node.searchQuery})
			.then((response) =>
			{ 
				if(response.data)
				{
					if(response.data.status == false)
					{
						node.callback(response.data.error_message,null);
					}
					else
					{
						this.ISPList = response.data.list;
						node.callback(null,this.ISPList);
					}

				}
				else
				{
					node.callback('Network Error',null);
				}
				

			}).catch((error) =>
			{
				node.callback('Network Error',null);
			})
			
		},
		utilities()
		{

			//set advertiser id
        	var uinfo = JSON.parse(localStorage['auth.currentUser']);
			if(uinfo.advertiser !== undefined){
				this.PageComponents.selected_advertiser = {name:uinfo.advertiser.name,id:uinfo.advertiser.id};
			}
			else
			{
				this.PageComponents.selected_advertiser = {name:'',id:0};
			}

			this.PageComponents.utilities_loading = true;
			 axios.post(appConfig.api+'campaigns/lineitem_utilities/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser"))})
			.then((response) =>
			{ 
				this.PageComponents.utilities_loading = false;

 				if(response.data)
				{
					if(response.data.status == false)
					{
						if(response.data.code == 401)
						{
							//invalud session
							this.$router.push('/logout');
						}
						else
						{
							this.PageComponents.hasError = true;
							this.PageComponents.errorMsgs = response.data.error_message;
						}
					}
					else
					{
						this.languagesList		= response.data.languages;
						this.deviceTypes		= response.data.device_type;
						this.devicePlatforms 	= response.data.device_platform;
						this.browsersList  	 	= response.data.browsers;
						this.connectionTypes	= response.data.connection_types;
						this.agegroupList		= response.data.age_group;
					}
				}
				else
				{
					this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
				}
			})
			.catch((error) =>
			{
				//other error
				this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
			})
		},
		closeLoop: function  (path) {
         return path.concat(path.slice(0, 1))
       }


  	},

	created: function() 
	{
	 this.get_list_details();
	 this.utilities();
	 this.getCountriesList();
  	},
	data() 
	{
		return {
			managers:{},
			listDeatils:
			{
				name:'',
				locations:[],
				farming_country:null
			},
			current_location:{lat:1, lng:1},
	  		zoom:2,
			PageComponents:{
				hasError:false,
				errorMsgs:[],
				loading:false
			},
			title: 'Data Farming - Edit List',
			items: [
				{
					text: 'Dashboard',
					href: '/',
				},
				{
					text: 'GEOfencing',
					href: '/audience/farming',
				},
				{
					text: 'Edit List',
					active: true,
				},
			],
			locationFields:
			[
				{ key: 'position', sortable: false,label:'Position' },
				{ key: 'radius', sortable: true,label:'Radius (meters)' },
				{ key: 'notes', sortable: false,label:'Notes' },
				{ key: 'id', sortable: false,label:'Remove'},
			],
			bulk_list:'',
			targeting:{
					device_type:null,
					device_platform:null,
					device_browser:null,
					device_isp:null,
					device_isp:null,
					device_connection:null
				},
			exchanges:[],
			applists:[],
			ISPList:null,
			websitesLists:[],
			GEOfencingList:[],
			languagesList:[],
			countiresList:[],
			deviceTypes:[],
			connectionTypes:[],
			devicePlatforms:[],
			CampaignsList:[],
			audianceLists:[],
			paths: [],
          	mvcPaths: null,
				}
	},
	computed: {
          polygonPaths: function () 
		  {
            if (!this.mvcPaths) return null

            let paths = [];
            for (let i=0; i < this.mvcPaths.getLength(); i++) {
              let path = [];
              for (let j=0; j<this.mvcPaths.getAt(i).getLength(); j++) {
                let point = this.mvcPaths.getAt(i).getAt(j);
                path.push({lat: point.lat(), lng: point.lng()});
              }
              paths.push(path);
            }

			paths = paths[0];

            return paths
          },
     },
	 watch: 
	 {
		
          polygonPaths: _.throttle(function (paths) {
            if (paths) {
              this.paths = paths;
            }
          }, 1000)
		  
		  
     },
}
</script>



<template>
	
	<Layout>
		<PageHeader :title="title" :items="items" />

		<b-alert variant="danger" show dismissible v-show="PageComponents.hasError">
			Please correct the following error(s):
			<ul>
				<li v-for="error in PageComponents.errorMsgs">{{ error }}</li>
			</ul>
		</b-alert>




		<div class="col-12" v-show="PageComponents.loading">
			<div class="text-center" style="margin: auto; padding-top: 23px;">
				<div class="text-muted font-size-13">Please wait we are submiting your information ...</div>
				<b-spinner
					label="Loading..."
					variant="primary"
					class="ml-3"
				></b-spinner>
			</div>
		</div>


			<div class="row" v-show="!PageComponents.loading">




					<!-- General-->
					<div class="col-12">
						<div class="card">
							<div class="card-body callbuilder">

							<h6 class="header-title mb-3">General</h6>
							
							<div class="row">
								<div class="col">
									<b-form-group label-cols-sm="10" label-cols-lg="2" label="Name" label-for="name" >
										<b-form-input id="name" v-model="listDeatils.name" placeholder="" :maxlength="50" ></b-form-input>

										<span class="help-block">
											<small>max. 50 characters</small>
										</span>
									</b-form-group>
								</div>
							</div>	


							<div class="row">
								<div class="col">
									<b-form-group label-cols-sm="10" label-cols-lg="2" label="Farming by" label-for="farming_type">
										<b-form-select v-model="listDeatils.farming_type"  class="mb-3"  text-field="farming_type" value-field="id" id="farming_type">
											<b-form-select-option value="location">Location</b-form-select-option>
											<b-form-select-option value="domain">Domain Name</b-form-select-option>
											<b-form-select-option value="appid">App ID</b-form-select-option>
											<b-form-select-option value="ip">IP Address</b-form-select-option>
										</b-form-select> 
									</b-form-group>
								</div>
							</div>	

						</div>	
					</div>	
					</div>	
					<!-- General-->





					<!-- Per Domain-->
					<div class="col-12" v-show="listDeatils.farming_type == 'domain'">
						<div class="card">
							<div class="card-body callbuilder">

							<h6 class="header-title mb-3">Domain</h6>
							
							<div class="row">
								<div class="col">
									<b-form-group label-cols-sm="10" label-cols-lg="2" label="Domain Name" label-for="domain_name" >
										<b-form-input id="domain_name" v-model="listDeatils.farming_value" placeholder="" :maxlength="50" ></b-form-input>
									</b-form-group>
								</div>
							</div>	
						</div>	
					</div>	
					</div>	
					<!-- Domain-->


					<!-- Per appid-->
					<div class="col-12" v-show="listDeatils.farming_type == 'ip'">
						<div class="card">
							<div class="card-body callbuilder">

							<h6 class="header-title mb-3">IP Address</h6>
							
							<div class="row">
								<div class="col">
									<b-form-group label-cols-sm="10" label-cols-lg="2" label="IP Address" label-for="ip" >
										<b-form-input id="ip" v-model="listDeatils.farming_value" placeholder="" :maxlength="50" ></b-form-input>
									</b-form-group>
								</div>
							</div>	
						</div>	
					</div>	
					</div>	
					<!-- Domain-->


					<!-- Per IP-->
					<div class="col-12" v-show="listDeatils.farming_type == 'appid'">
						<div class="card">
							<div class="card-body callbuilder">

							<h6 class="header-title mb-3">IP Address</h6>
							
							<div class="row">
								<div class="col">
									<b-form-group label-cols-sm="10" label-cols-lg="2" label="App Bundle" label-for="appid" >
										<b-form-input id="appid" v-model="listDeatils.farming_value" placeholder="" :maxlength="50" ></b-form-input>
									</b-form-group>
								</div>
							</div>	
						</div>	
					</div>	
					</div>	
					<!-- IP-->



					<!-- location list -->
					<div class="col-12" v-show="listDeatils.farming_type == 'location'">
						<div class="card">
							<div class="card-body callbuilder">
								

						

								
								<div class="row">
									<div class="col">
										<h6 class="header-title mb-3">Locations</h6>
									</div>
								</div>	

								<div class="row">
									<div class="col">
										<b-form-group label-cols-sm="10" label-cols-lg="2" label="Country" >
											<b-form-select  class="mb-3" v-model="listDeatils.farming_country" :options="countiresList" value-field="id" text-field="label" id="country"></b-form-select> 
										</b-form-group>
									</div>
								</div>	


								<div class="row">
									<div class="col">
										<div role="group" class="form-row form-group">
											
											<label for="name" class="col-sm-10 col-lg-2 col-form-label">Search for location</label>

											<br /><br />

											<div class="col">
												<gmap-autocomplete  class="form-control" @place_changed="setPlace"></gmap-autocomplete>


												<GmapMap :center="current_location" ref="map"  :zoom="zoom"  map-type-id="terrain" style="width: 100%; height: 450px;margin-top:10px;">
													

													<gmap-polygon v-if="paths.length > 0" :paths="paths" :editable="true" @paths_changed="updateEdited($event)" @rightclick="handleClickForDelete" ref="polygon"> </gmap-polygon>
													<GmapMarker  :key="index" v-for="(m, index) in listDeatils.locations" :position="m.position" />
												</GmapMap>

											</div>
										</div>
									</div>
								</div>	


							
								
							</div>
						</div>		
					</div>	
					<!-- location list -->


					<!-- General
					<div class="col-12" v-show="listDeatils.farming_type == 'location'">
						<div class="card">
							<div class="card-body callbuilder">

							<h6 class="header-title mb-3">Technology</h6>

							<div class="row">
									<div class="col">
											<b-form-group label-cols-sm="10" label-cols-lg="2" label="Device Type" >
												<treeselect v-model="targeting.device_type" placeholder="All" :multiple="true" :options="deviceTypes" />
											</b-form-group>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<b-form-group label-cols-sm="10" label-cols-lg="2" label="Device Platform" >
												<treeselect v-model="targeting.device_platform" placeholder="All" :multiple="true" :options="devicePlatforms" />
											</b-form-group>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<b-form-group label-cols-sm="10" label-cols-lg="2" label="Browser" >
												<treeselect v-model="targeting.device_browser" placeholder="All" :multiple="true" :options="browsersList" />
											</b-form-group>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<b-form-group label-cols-sm="10" label-cols-lg="2" label="ISP" >
												<treeselect v-model="targeting.device_isp" placeholder="All" :multiple="true"  :async="true" :options="ISPList" :load-options="getISPList" :loading="true" :auto-load-root-options="false" />
											</b-form-group>
										</div>
									</div>

									<div class="row">
										<div class="col">
											<b-form-group label-cols-sm="10" label-cols-lg="2" label="Connection Type" >
												<treeselect v-model="targeting.device_connection" placeholder="All" :multiple="true" :options="connectionTypes" />
											</b-form-group>
										</div>
									</div>



							</div>	

						</div>	
					</div>	
				General-->



					<!-- Submit-->
					<div class="col-12">
						<div class="card">
							<div class="card-body callbuilder">
	
								<div class="form-group text-right m-b-0">
									<button class="btn btn-primary" type="button" v-on:click="edit_list">Submit</button>
									
								</div>
							</div>
						</div>		
					</div>	
					<!-- Submit -->

			</div>	
	
		<!-- domain form -->

	</Layout>
</template>
